import amplitude from 'amplitude-js';
import isPlainObject from 'lodash/isPlainObject';
import { DateTime, Settings } from 'luxon';

export const initAmplitude = (): void => {
  amplitude.getInstance().init(window.el8Globals.AMPLITUDE_API_KEY, null, { disableCookies: true });
};

export const logEvent = (eventType: string, eventData = {}): void => {
  amplitude.getInstance().logEvent(eventType, eventData);
};

/**
 * Helper function to update multiple user props.
 * @param {Object} userProps - object with key/values that we want to update
 * on user
 */

type UserProps = {
  [key: string]: any;
};
export const updateUser = (userProps: UserProps): void => {
  if (!isPlainObject(userProps)) {
    throw new Error(`Incorrect user props. Expected a plain object`);
  }
  const identify = Object.keys(userProps).reduce(
    (resultIdentity, key) => resultIdentity.set(key, userProps[key]),
    new amplitude.Identify(),
  );
  amplitude.getInstance().identify(identify);
};

export const handleAmplitudeError = (eventName: string, err: Error): void => {
  // eslint-disable-next-line no-console
  console.warn(`Failed to log event "${eventName}":`, err);
};

/**
 * Helper functions for analytics
 */

let startTime: DateTime;

export const setStartTime = (): void => {
  startTime = DateTime.fromObject({ zone: Settings.defaultZone });
};

export const getStartTime = (): DateTime => startTime;
